// Core lib dependencies.
import Immutable		from 'seamless-immutable';

// Import action types.
import ActionTypes  	from './actionTypes.js';

// Config.
import Config			from './config/config.js';

// Initial state.
var initialState = Immutable({
	totalInstances:0,
	instances:{}
});

// Initial state of a new instance.
var initialInstanceState = Immutable({
	open:false,
	visible:false,
	positionMode:Config.positionMode,
	top:Config.top
});

/**
 * <pre>
 * Overlay module Reducer(s).
 *
 * Summary of responsibilities:
 *
 *  - responds to actions, receives current Redux state and modifies it accordingly.
 *
 * FYI:
 *
 * All {@link https://github.com/reactjs/redux|Redux} state modifications are handled using {@link https://github.com/rtfeldman/seamless-immutable|Seamless-immutable} objects and methods.
 * DO NOT DIRECTLY MODIFY THE REDUX STATE (Immutable should stop you from doing this, but just in case)!
 * </pre>
 *
 * @see {@link https://github.com/reactjs/redux|Redux Documentation}
 * @see {@link https://github.com/rtfeldman/seamless-immutable|Immutable Documentation}
 *
 * @author Tim Loram
 *
 * @memberof module:Overlay
 * @namespace
 *
 * @type {Object}
 */
const Reducer = {

	/**
	 * Reducer for the Overlay actions.
	 *
	 * @param state: 	{object} The current Redux state.
	 * @param action: 	{object} The current Redux action object.
	 */
	rootReducer: (state = initialState, action) => {

		// Execute the appropriate logic based on the received action type.
		switch (action.type) {

			// Register an instance of an overlay.
			case ActionTypes.REGISTER_INSTANCE:

				// Register initial instance.
				state = state.setIn(['instances', action.id], initialInstanceState);

				// Increment instance count.
				state = state.set('totalInstances', state.totalInstances+1);

				return state;

			break;

			// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
			// Open overlay.
			case ActionTypes.OPEN:

				// Update property.
				state = state.setIn(['instances', action.id, 'open'], true);

				return state;

			break;

			// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
			// Close overlay.
			case ActionTypes.CLOSE:

				// Update property.
				state = state.setIn(['instances', action.id, 'open'], false);

				// Remove instance.
				state = state.set('instances', state.instances.without(action.id));

				// Decrement instance count.
				state = state.set('totalInstances', state.totalInstances-1);

				return state;

			break;

			// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
			// Center overlay
			case ActionTypes.CENTER:

				// Update property.
				state = state.setIn(['instances', action.id, 'top'], action.top);

				return state;

			break;

			// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
			// Update positioning mode.
			case ActionTypes.UPDATE_POSITION_MODE:

				// Update property.
				state = state.setIn(['instances', action.id, 'positionMode'], action.positionMode);

				return state;

			break;

			// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
			// Update visibility.
			case ActionTypes.UPDATE_VISIBILITY:

				// Update property.
				state = state.setIn(['instances', action.id, 'visible'], action.visible);

				return state;

			break;

			// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
			// Make sure to return a state even if no action was matched!
			default:
				return state;
		}
	}
}

export default Reducer;